<app-navbar class="fixed w-dvw top-0 z-10" />
<main>
  <router-outlet />
</main>
